<div class="px-2 relative" [class.pointer-events-none]="this.cooldownActive">
  <p class="font-bold mb-0 mt-4 pl-2">
    Commander mon repas
  </p>
  <mk-establishment-selector #selector
    (establishmentRemoveRequest)="this.establishmentRemoveRequest($event)"
    (establishmentSelected)="this.selectedRestaurantChanged($event)"
    (subEstablishmentSelected)="this.subEstablishmentSelected($event)"
    [canRemoveEstablishments]="true"
    [establishments]="this.restaurantHistory"
    [selectedEstablishment]="this.selectedRestaurant"
    [selectedSubEstablishment]="this.sub"
    class="text-[.7rem]"
    id="establishment-selector"
    establishmentType="restaurants"/>

    @if (this.cooldownActive) {
      <div class="absolute top-0 left-0 w-full h-full bg-noir-2-contour opacity-50 flex items-center justify-center pointer-events-none z-[999]">
        <span class="material-icons block text-6xl animate-spin">
          hourglass_top
        </span>
      </div>
    }
  </div>

  <hr class="border-noir-2-contour my-4 border"/>
  @if (this.selectedRestaurant !== undefined) {
    <div class="px-2 relative">
      @if (this.perfos.length > 0) {
        <div class="w-full flex items-center">
          <p class="font-bold">{{this.monthName}}</p>
          <a class="ml-auto text-xs underline" href="javascript:void(0);" (click)="this.displayPerfosModal(this.perfos)">Voir les indices égalim</a>
          <span class="material-icons ml-1 block mt-1">
            more_horiz
          </span>
        </div>
      }
      @if (this.perfos.length > 0) {
        <div class="flex items-center gap-2 my-2">
          @for (perf of this.perfos.slice(0, 2); track perf) {
            <div class="flex-1 rounded bg-noir-2 border-noir-2-contour border-1 flex flex-col p-3 gap-2">
              <mk-circular-progress-bar [value]="perf.value" [barColor]="perf.color" />
              <p class="text-center w-full">{{perf.name}}</p>
            </div>
          }
        </div>
      }
    </div>
  }

  @if (this.selectedRestaurant !== undefined && this.perfos.length > 0) {
    <hr class="border-noir-2-contour my-4 border"/>
  }

  @if (this.tipOfTheDay && this.tipOfTheDay.length > 0) {
    <div class="px-4 mt-auto pb-4">
      <div class="rounded bg-vert-1 fg-gris-14 px-4 py-5 saviez-vous min-h-48">
        <p class="font-bold text-lg mb-2">
          Le saviez-vous ?
        </p>
        <p [innerText]="this.tipOfTheDay" class="font-medium w-3/5 text-xs">
        </p>
        @if (this.tipType === 'citation' && this.tipOfTheDayAuthor.length > 0) {
          <p class="text-xs font-medium" [innerText]="'- ' + this.tipOfTheDayAuthor">
          </p>
        }
      </div>
      <div class="w-full flex items-center gap-1 justify-center mt-2 font-medium underline-offset-2">
        @if (this.companyData && this.companyData.cgvPath) {
          <a class="text-sm underline cursor-pointer" target="_blank" [attr.href]="this.boGestionUrl + '/' + this.companyData.cgvPath">CGV</a>
        }
        @if (this.companyData && this.companyData.cgvPath) {
          <span class="mx-1">•</span>
        }
        @if (this.selectedRestaurant) {
          <a class="text-sm underline cursor-pointer" (click)="this.showRestaurantInformations()">Contactez-nous</a>
        }
      </div>
    </div>
  }
